import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/projectCategory/projectCategoryAction";
import * as uiHelpers from "../ProjectCategoryUIHelpers";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters/ActionsColumnsFormatter";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { useProjectCategoryUIContext } from "../ProjectCategoryUIContext";
import { RoleChecker } from "../../../../RoleChecker";
// import { ToastContainer } from 'react-toastify';

const ProjectCategoryTable = (props) => {
  // Project UI Context
  const projectCategoryUIContext = useProjectCategoryUIContext();
  const projectCategoryUIProps = useMemo(() => {
    return {
      queryParams: projectCategoryUIContext.queryParams,
      setQueryParams: projectCategoryUIContext.setQueryParams,
      openEditProjectCategoryPage: projectCategoryUIContext.openEditProjectCategoryPage,
      openDeleteProjectCategoryPage: projectCategoryUIContext.openDeleteProjectCategoryPage,
    };
  }, [projectCategoryUIContext]);

  // Getting curret state of project list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.projectCategory }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    dispatch(actions.fetchProjectCategories(projectCategoryUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectCategoryUIProps.queryParams, dispatch]);

  const allowEdit = RoleChecker("Edit", "project");

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Nama Kategori Penyaluran",
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditProjectCategoryPage: 
          projectCategoryUIProps.openEditProjectCategoryPage,
        openDeleteProjectCategoryPage:
          projectCategoryUIProps.openDeleteProjectCategoryPage,
        allowEdit,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: projectCategoryUIProps.queryParams.pageSize,
    page: projectCategoryUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                    projectCategoryUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default ProjectCategoryTable;
